// Every word that is not a drama title comes from the site's settings (Wording), so a site can be rebranded or
// translated from the dashboard. The standard wording is in the settings' defaults, not here.
export function createText(design) {
  const t = (key) => {
    const v = design['text.' + key];
    return typeof v === 'string' && v ? v : key;
  };
  const fill = (s, vars) => String(s).replace(/\{(\w+)\}/g, (m, k) => (k in vars ? vars[k] : m));
  return { t, fill };
}
